import Typography from "@material-ui/core/Typography";
import React, { useState, useEffect } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import { format } from "date-fns";
import Modal from "@mui/material/Modal";
import store from '../../store'
import { useSelector } from "react-redux";
import { Avatar, makeStyles, Button, Grid,  } from "@material-ui/core";
import { Checkbox, Popover } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import Footer from "./Footer";
import Top from "./Top";
// import { getNotice, setNoticeHide } from '../../actions/messages'
import kefuUrl from "../../assets/svg/kefu.svg";
import emailSvg from "../../assets/svg/email.svg";
import { display, width } from "@mui/system";

const useStyles = makeStyles((theme) => {
  return {
    root: {
      display: "flex",
      width: '100%',
      height: '100%'
    },
    page: {
      width: "100%",
      minHeight: "100vh",
      padding: "0",
      background: "#F0F2F5",
      display: "flex",
      flexDirection: 'column'
    },
    appbar: {
      width: `calc(100% - 208px)`,
      backgroundColor: "#fff",
      boxShadow: "0px 1px 4px 0px rgba(0, 21, 41, 0.12)",
      color: "#000",
    },
    toobar: theme.mixins.toolbar,
    date: {
      flexGrow: 1,
    },
    avatar: {
      width: "24px",
      height: "24px",
      marginRight: theme.spacing(1),
      color: "yellow",
      backgroundColor: "green",
    },
    boyingTxt: {
      width: 100,
      height: 50,
      marginRight: "30px",
    },
    box: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "800px",
      padding: '20px 0',
      background: "#fff",
      boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.2)",
      borderRadius: "4px",
      zIndex: '120'
    },
    contentBox: {
      width: '100%',
      maxHeight: '70vh',
      marginTop: '24px',
      padding: '0 40px',
      overflow: 'auto',
      whiteSpace: 'pre'
    },
    icon: {
      position: 'absolute',
      right: '-10px',
      top: '-10px',
      width: '30px',
      height: '30px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '1px solid #1890ff',
      background: '#fff',
      borderRadius: '50%',
      cursor: 'pointer',
    },
    title: {
      width: "90%",
      minHeight: "50px",
      margin: '0 auto',
      padding: "13px 20px",
      textAlign: 'center',
      fontSize: "18px !important",
      lineHeight: '24px',
      color: "#333",
      boxSizing: "border-box",
      fontWeight: "bold !important",
    },
    subTitle: {
      fontSize: "14px !important",
      lineHeight: '20px',
      color: "#666",
      textAlign: 'center',
    },
    time: {
      marginLeft: '40px'
    },
    content: {
      width: '100%',
      fontSize: '14px !important',
      color: "#333",
      lineHeight: '19px'
    },
    footer: {
      width: '100%',
      marginTop: '20px',
      padding: '0 40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end'
    },
    btn: {
      marginLeft: '10px',
      fontSize: '14px !important',
      color: '#1890ff',
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline'
      }
    },
    kefu: {
      position: 'fixed',
      right: '14px',
      bottom: '30px',
      width: '60px',
      height: '60px',
      borderRadius: '50%',
      background: '#0F55A4',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: '100',
      cursor: 'pointer',
      '& img': {
        width: '36px',
        height: '36px'
      }
    },
    email: {
      position: 'fixed',
      right: '14px',
      bottom: '100px',
      width: '60px',
      height: '60px',
      borderRadius: '50%',
      background: '#0F55A4',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: '100',
      cursor: 'pointer',
      '& img': {
        width: '36px',
        height: '36px'
      }
    }
    
  };
});

export default function Layout({ children }) {

 
  const classes = useStyles();
  const username = useSelector((state) => state.auth.username);
  const [isInit, setIsInit] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [checked, setChecked] = useState(false)
  const [noticeObj, setNoticeObj] = useState({ })
  const [cancelObj, setCancelObj] = useState({ })

  useEffect(() => {
    setTimeout(() => {
      let showModal = store.getState().auth.showModal
      let isClose = localStorage.getItem('isModalClose')
      if (showModal && isClose != '1' ) {// 关闭后不再弹出
        if (!isInit) {
          setIsInit(true)
          checkModal()
        }
      }
    }, 800)
  }, [])

  const doCancel = () => {
    localStorage.setItem('isModalClose', '1')
    if (checked) {
      setNoticeHide(cancelObj)
    }
    setShowModal(false)
  }

  const checkModal = () => {
    // 调用接口获取弹框内容
    getNotice().then(res => {
      if (res.data) {
        let data = res.data
        let noticeObj = {
          title: data.notice_title,
          content: data.notice_content,
          author: data.notice_author,
          createTime: data.notice_publish_time.substring(0, 10),
          userId: data.user_id
        }
        setNoticeObj(noticeObj)
        setShowModal(true)
        setCancelObj({
          notice: data.notce_id,
          user: data.user_id
        })
      }
    })
  }

  const toKefu = () => {
    let a = document.createElement('a')
    a.href = 'https://qab.mageia.site/'
    a.target = '_blank'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  const changeCheckbox = (e) => {
    setChecked(e.target.checked)
  }

  const handleClick = () => {
    window.location.href ='mailto:service@msecu.com';
  }

  return (
    <div className={classes.root}>
      <div className={classes.page}>
        <Top />
        
        <Popover content="Ai 医疗法规问答" placement="left">
          <div className={classes.kefu} onClick={toKefu}>
            <img src={kefuUrl} alt="" />
          </div>
        </Popover>
        <Popover content="反馈与需求，点击发送" placement="left">
          <div className={classes.email} onClick={handleClick}>
            <img src={emailSvg} alt="" />
          </div>
        </Popover>

        {children}
      </div>

      <Modal
        open={showModal}
        onClose={doCancel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div >
          <Grid className={classes.box}>
            <Typography variant="span" className={classes.icon} onClick={doCancel}>
              <CloseOutlined style={{ fontSize: '14px', color: '#1890ff' }}/>
            </Typography>
            <Typography className={classes.title}>
              {noticeObj.title}
            </Typography>

            <Typography className={classes.subTitle}>
              <Typography variant="span" >
                作者：{noticeObj.author}
              </Typography>
              <Typography variant="span" className={classes.time}>
                发布时间：{noticeObj.createTime}
              </Typography>
            </Typography>
            <Grid className={classes.contentBox}>
              
              <Typography className={classes.content}>
                {noticeObj.content}
              </Typography>
            </Grid>
            <Typography className={classes.footer}>
              <Checkbox onChange={changeCheckbox}>不再提示</Checkbox>
              <Typography variant="span" className={classes.btn} onClick={doCancel}>
                关闭
              </Typography>
            </Typography>
          </Grid>
        </div>
      </Modal>
    </div>
  );
}
